angular.module('igs.common.validation', [])

    .directive('igsCommonValid', [
        function () {
            'use strict';
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function ($scope, $elem, $attr, $ctrl) {
                    var isValid = function () {
                        return $scope.$eval($attr['igsCommonValid']);
                    }

                    $ctrl.$setValidity('verify', !!isValid());

                    $scope.$watch(isValid, function () {
                        $ctrl.$setValidity('verify', !!isValid());
                    });
                }
            };
        }
    ]);

angular.module('igs.common.validation').directive('igsPersistValue', [
    function () {
        'use strict';
        return {
            restrict: 'E',
            scope: {
                from: '=',
                to: '=',
                propertyName: '=?'
                // If we do not use both Object and Property Name then this will break in transcluded directives
                // such as ngInclude
            },
            link: function ($scope) {

                if ($scope.propertyName && _.isString($scope.propertyName)) {
                    $scope.$watch('from', function () {
                        if ($scope.to) {
                            $scope.to[$scope.propertyName] = $scope.from;
                        }
                    });

                } else if (!$scope.propertyName) {
                    $scope.$watch('from', function () {
                        if ($scope.to) {
                            $scope.to = $scope.from;
                        }
                    });

                } else {
                    throw 'Property Name must be a string on directive igsPersistValue';
                }
            }
        };
    }
]);